import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import logo from "../assests/viyash 1.svg";

const MenuIcon = () => (
  <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="#003399" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const CloseIcon = () => (
  <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="#003399" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const primaryLinks = [
  { label: "Home", href: "/" },
  { label: "About Viyash", href: "/about" },
  { label: "Intermediates", href: "/intermediates" },
  { 
    label: "API", 
    href: "/api",
    dropdown: [
      { label: "Human API", href: "/api#api-portfolio" },
      { label: "Animal API", href: "/api#pta-section" }
    ]
  },
  { label: "Human Health", href: "/human-health" },
  { label: "Animal Health", href: "/animal-health" },
  //  { label: "Animal Health", href: "https://alivira.co.in/vet-formulation/" },
  { label: "CDMO & Capabilities", href: "/cdmo" },
  { label: "Manufacturing & Quality", href: "/manufacturing-quality" },
];

const secondaryLinks = [
  { label: "Investors", href: "/investor-relation" },
  { label: "Sustainability & CSR", href: "/sustainability" },
  { label: "Careers", href: "/careers" },
  { label: "Contact", href: "/contact" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Helper to determine active link based on current path
  const isActive = (href) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname.startsWith(href);
  };

  // Smooth-scroll handler for dropdown anchor links
  const handleDropdownClick = (e, sublink) => {
    e.preventDefault();
    const [path, hash] = sublink.href.split("#");
    const scrollToHash = () => {
      if (hash) {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    if (location.pathname === path) {
      // Already on the right page, just scroll
      scrollToHash();
    } else {
      // Navigate then scroll after page mounts
      navigate(path);
      setTimeout(scrollToHash, 350);
    }
    setMenuOpen(false);
  };

  return (
    <header className="header">

      {/* Primary Nav */}
      <nav className="primary-nav">

        <Link to="/" className="logo">
          <img src={logo} alt="Viyash" className="logo-img" />
        </Link>

        <div className="nav-spacer"></div>

        {/* Desktop Links */}
        <ul className="desktop-links">
          {primaryLinks.map((link) => (
            <li key={link.label} className={link.dropdown ? "nav-item-dropdown" : ""}>
              <Link
                to={link.href}
                className={`primary-link ${isActive(link.href) ? "active" : ""}`}
              >
                {link.label}
              </Link>
              {link.dropdown && (
                <ul className="dropdown-menu">
                  {link.dropdown.map((sublink) => (
                    <li key={sublink.label}>
                      <a
                        href={sublink.href}
                        className="dropdown-link"
                        onClick={(e) => handleDropdownClick(e, sublink)}
                      >
                        {sublink.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="hamburger"
          aria-label="Toggle menu"
        >
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="mobile-menu">

          {primaryLinks.map((link) => (
            <div key={link.label}>
              <Link
                to={link.href}
                onClick={() => {
                  if (!link.dropdown) setMenuOpen(false);
                }}
                className={`mobile-link ${isActive(link.href) ? "active" : ""}`}
              >
                {link.label}
              </Link>
              {link.dropdown && (
                <div className="mobile-dropdown-menu">
                  {link.dropdown.map((sublink) => (
                    <a
                      key={sublink.label}
                      href={sublink.href}
                      onClick={(e) => handleDropdownClick(e, sublink)}
                      className="mobile-dropdown-link"
                    >
                      {sublink.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div className="mobile-divider"></div>

          {secondaryLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              onClick={() => {
                setMenuOpen(false);
              }}
              className={`mobile-secondary-link ${isActive(link.href) ? "active" : ""}`}
            >
              {link.label}
            </Link>
          ))}

        </div>
      )}

      {/* Secondary Nav Desktop */}
      <nav className="secondary-nav">
        <ul className="secondary-links">
          {secondaryLinks.map((link) => (
            <li key={link.label}>
              <Link
                to={link.href}
                className={`secondary-link ${isActive(link.href) ? "active" : ""}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

    </header>
  );
};

export default Header;